import {
  ContentBlocks,
  contentBlocksQuery,
} from '@/components/contentBlocks/ContentBlocks'
import { Hero } from '@/components/Hero'
import { statamicGraphqlEndpoint } from '@/globals/globals'
import { Box } from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticProps } from 'next'

export const getStaticProps: GetStaticProps = async () => {
  const data = await request(
    statamicGraphqlEndpoint,
    gql`
      query MyQuery {
        entry(collection: "pages", slug: "partner") {
          title
          id
          ... on Entry_Pages_Default {
            id
            heading
            pre_heading
            intro
            ${contentBlocksQuery}
          }
        }
      }
    `
  )

  return {
    props: {
      data: data.entry,
    },
    revalidate: 60,
  }
}

export const Page = ({ data }: any) => {
  return (
    <>
      <Hero heading={data.title} subheading={data.intro} />
      <Box pb={20}>
        <ContentBlocks {...data} />
      </Box>
    </>
  )
}

export default Page
